import { graphql } from "../__generated__/gql";

export const GET_HS92_PRODUCTS_QUERY = graphql(`
  query GetHS92Products($servicesClass: ServicesClass) {
    section: productHs92(productLevel: 1, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    twoDigit: productHs92(productLevel: 2, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    fourDigit: productHs92(productLevel: 4, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    sixDigit: productHs92(productLevel: 6, servicesClass: $servicesClass) {
      ...ProductMetadata
    }
  }

`);

export default GET_HS92_PRODUCTS_QUERY;
